import { CategoryType } from "@features/orders-features/types/drawer";

export function getCategoryType(
  productType: string,
): Exclude<CategoryType, "all"> {
  const value = productType.toUpperCase();
  if (value.includes("HARDWARE")) {
    return "hardware";
  }
  if (value.includes("ACCESSOR")) {
    return "accessories";
  }
  if (value.includes("SOFTWARE") || value.includes("LICENSE")) {
    return "software";
  }
  if (value.includes("SERVICE") || value.includes("FEES")) {
    return "services";
  }
  return "other";
}

export function getCategoryLabel(productType: string): string {
  const value = productType.toUpperCase();
  if (value.includes("HARDWARE")) return "Hardware";
  if (value.includes("ACCESSOR")) return "Accessories";
  if (value.includes("SOFTWARE") || value.includes("LICENSE"))
    return "Software";
  if (value.includes("SERVICE")) return "Services";
  if (value.includes("FEES")) return "Fees";
  return "Other";
}
